import { forwardRef, KeyboardEventHandler } from 'react'

import { Icon, IconName } from '~/src/components/generic/PhosphorIcons/index'

import { tw } from '~/lib/utils'

type Props = {
  title: string
  active: boolean
  open: boolean
  icon: IconName
  menuId: string
  onFocus?: () => void
  onMouseEnter?: () => void
  onKeyDown?: KeyboardEventHandler<HTMLButtonElement>
}

const SidebarMenuButton = forwardRef<HTMLButtonElement, Props>(
  ({ title, active, open, icon, menuId, onFocus, onMouseEnter, onKeyDown }, ref) => {
    return (
      <button
        aria-controls={menuId}
        aria-expanded={open}
        className={tw(
          'flex w-full cursor-pointer items-center justify-center py-2 transition hover:bg-ryder-red-primary/70 focus:bg-ryder-red-primary/70 focus:outline-none',
          active ? 'border-l-4 border-ryder-red-secondary bg-gray-700' : ''
        )}
        ref={ref}
        type="button"
        onFocus={onFocus}
        onKeyDown={onKeyDown}
        onMouseEnter={onMouseEnter}
      >
        <div className="flex flex-col items-center space-y-2">
          <Icon color="#fff" name={icon} size="24" />
          <p className="text-label-xs font-normal text-inverted">{title}</p>
        </div>
      </button>
    )
  }
)

SidebarMenuButton.displayName = 'SidebarMenuButton'

export default SidebarMenuButton
